document.addEventListener('turbo:load', function() {
  if(document.getElementById('breadcrumb')) {
    let breadcrumb = document.getElementById('breadcrumb').scrollWidth
    $('#breadcrumb').scrollLeft(breadcrumb)
  }
})